module.exports = __webpack_public_path__ + "img/info.583bafa1.svg";